import { ModalScreen } from "../modal-screen";
import { customElement, property, state } from "lit/decorators.js";
import { html } from "lit";
import gameApp from "@/index";

@customElement("moderator-settings")
export class ModeratorPanel extends ModalScreen {
  @property({ type: Array }) tabs: any = [];
  @property({ type: String }) activeTab: string = "";
  @state() userId: string = "";
  @state() reason: string = "";
  @state() duration: string = "";
  roomId: string;
  clientId: string;

  constructor() {
    super();
  }

  async connectedCallback() {
    super.connectedCallback();
  }

  async openModal(clientId: string) {
    this.isOpen = true;

    this.tabs = [
      { slug: "mute", label: "Mute" },
      { slug: "ban", label: "Ban" },
    ];

    this.selectTab("mute");

    this.clientId = clientId;
  }

  selectTab(tabId: string) {
    this.activeTab = tabId;
  }

  async handleMuteUser(e: Event) {
    e.preventDefault();
    try {
      gameApp.wsClient.sendMessage(
        JSON.stringify({
          action: "moderation_actions",
          arguments: {
            action: "mute-user",
            clientId: this.clientId,
            reason: this.reason,
            duration: this.duration,
          },
        })
      );
    } catch (error) {
      console.error("Error muting user:", error);
    }
  }

  handleInputChange(e: Event) {
    const target = e.target as HTMLInputElement;
    const { id, value } = target;
    if (id === "userId") this.userId = value;
    if (id === "reason") this.reason = value;
    if (id === "duration") this.duration = value;
  }

  render() {
    if (!this.isOpen) {
      return html``;
    }

    return html`
      <div class="modal">
        <div class="modal__top">
          ${this.tabs.map(
            (tab) => html`
              <span
                class="modal__tab ${this.activeTab === tab.slug
                  ? "is-active"
                  : ""}"
                @click="${() => this.selectTab(tab.slug)}"
              >
                ${tab.label}
              </span>
            `
          )}
          <button class="modal__close" @click="${this.closeModal}">
            <span>Close</span>
          </button>
        </div>

        <div class="modal__body">
          <div class="modal__results">
            ${this.activeTab === "mute"
              ? html`
                  <form @submit="${this.handleMuteUser}">
                    <label for="reason">Reason:</label>
                    <textarea
                      id="reason"
                      style="position: relative; z-index: 999;"
                      .value="${this.reason}"
                      @input="${this.handleInputChange}"
                    ></textarea>

                    <br /><br />
                    <label for="duration">Duration (minutes):</label>
                    <input
                      id="duration"
                      type="text"
                      style="position: relative; z-index: 999;"
                      .value="${this.duration}"
                      @input="${this.handleInputChange}"
                    />
                    <button type="submit">Mute</button>
                  </form>
                `
              : ""}
          </div>
        </div>
      </div>
    `;
  }
}
